export const USER_SCOPES = [
    'av:portal:access',
    'av:api-keys:read',
    'av:api-keys:create',
    'av:api-keys:delete',
    'av:transactions:read',
    'av:transactions:create',
    'av:payment-tokens:create',
    'av:payment-tokens:read',
    'av:payment-tokens:delete'
]

export const VERSION = "4.4.1";